import { render, staticRenderFns } from "./SeriesPreview.vue?vue&type=template&id=a99dcc6a&"
import script from "./SeriesPreview.vue?vue&type=script&lang=js&"
export * from "./SeriesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports